import React from "react";
import { Form, Dropdown, Input } from "semantic-ui-react";
import { useFormik } from "formik"; //formik sirve para manejar formularios en react y es muy util para hacer validaciones
import { initialValues, validationSchema } from "./MenuForm.form";
import { Menu } from "../../../../api"; //aqui obtenemos las funciones de la clase Menu
import { useAuth } from "../../../../hooks"; // aqui obtenemos el token del usuario autenticado
import "./MenuForm.scss";

const menuController = new Menu();

export function MenuForm(props) {
  const { onClose, onReload, menu } = props; //recibimos las propiedades que nos llegan desde el componente Menu.js
  const { accessToken } = useAuth(); //obtenemos el token del usuario autenticado

  const options = [
    { key: "https://", text: "https://", value: "https://" },
    { key: "http://", text: "http://", value: "http://" },
    { key: "/", text: "/", value: "/" },
  ];

  const formik = useFormik({
    initialValues: initialValues(menu), //inicializamos los valores del formulario
    validationSchema: validationSchema(),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        const data = {
          title: formValue.title,
          path: `${formValue.protocol}${formValue.path}`,
          order: formValue.order,
          active: formValue.active,
        };
        console.log("data", data);
        console.log("menu", menu);
        if (menu) {
          data.path = formValue.path; //esto es para que no se duplique el protocolo ymuestre hhtps://
          await menuController.updateMenu(accessToken, menu._id, data);
        } else {
          await menuController.createMenu(accessToken, data);
        }
        onReload();
        onClose();
      } catch (error) {
        console.log("error", error);
      }
    },
  });

  return (
    <Form onSubmit={formik.handleSubmit}>
      <Form.Group widths="equal">
        <Form.Input
          name="title"
          placeholder="Titulo"
          onChange={formik.handleChange}
          value={formik.values.title}
          error={formik.errors.title}
        />

        <Form.Input
          name="order"
          type="number"
          placeholder="Order"
          onChange={formik.handleChange}
          value={formik.values.order}
          error={formik.errors.order}
        />
      </Form.Group>

      <Input
        name="path"
        placeholder="URL"
        fluid
        onChange={formik.handleChange}
        value={formik.values.path}
        error={formik.errors.path}
        label={
          !menu ? (
            <Dropdown
              options={options}
              onChange={(e, data) =>
                formik.setFieldValue("protocol", data.value)
              }
              value={formik.values.protocol}
              error={formik.errors.protocol}
            />
          ) : null
        }
      />

      <Form.Group />
      <Form.Button type="submit" primary fluid loading={formik.isSubmitting}>
        {menu ? "Actualizar menu" : "Crear menu"}
      </Form.Button>
    </Form>
  );
}
